import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator';
import { KeysPost } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { post } from '../../../../model/post';
import { tag } from '../../../../model/tag';
import { push, goBack } from 'connected-react-router';

export interface IActions {
    navigateTo: (path: string) => void;
    goBack: () => void;
    getContent: (post: post) => any;
    savePost: (post: post) => any;
    changeDescription: (post: post, Campo: string) => void;
    changeSurveyText: (post: post, Campo: string) => void;
    changeTitle: (post: post, Campo: string) => void;
    newPost: () => void;
    changeRTE: (post: post, Campo: string) => void;
    changeAssociatedTag: (post: post, tag: tag) => void;
    changeYesNoQuestion: (post: post, newValue: boolean) => void;
    getPost: (Id: string) => void;
    deletePost: (Id: string) => void;
    clearFields: () => void;
    loadVotes: (idPost: string) => any;
    loadStatsVote: (idPost: string) => any;
    changeImageBase64: (post: post, newValue: string) => void;

    loadDrafts: (title?: string, description?: string, yesNoQuestion?: boolean) => void;
    loadDelivered: (title?: string, description?: string, yesNoQuestion?: boolean) => void;

    deliverPost: (post: post) => void;

    print: (postIds: string[]) => any;
    download: (postIds: string[]) => any;
}

let AlterDescription = (post: post, newValue: string) => {
    post.description = newValue;
    return post;
}
let AlterSurveyText = (post: post, newValue: string) => {
    post.surveyText = newValue;
    return post;
}
let AlterTitle = (post: post, newValue: string) => {
    post.title = newValue;
    return post;
}
let AlterRTE = (post: post, newValue: string) => {
    post.rawdata = newValue;
    return post;
}
let alterYESNO = (post: post, newValue: boolean) => {
    post.hasYesNoQuestion = newValue;
    return post;
}
let AlterAssociatedTag = (post: post, tag: tag) => {
    console.log("TAG", tag);
    console.log("POST", post);
    if (post.tags) {
        const curr = post.tags.findIndex(t => t && t.code === tag.code);
        const selected = [...post.tags];
        if (curr > -1) {
            selected.splice(curr, 1);
        } else {
            selected.push(tag);
        };
        post.tags = selected;
    }
    return post;
}
let alterImageBase64 = (post: post, newValue: string) => {
    post.imagebase64 = newValue;
    return post;
}
let clearFields = () => {
    const post: post = {
        _id: ``,
        description: ``,
        rawdata: ``,
        delivered: false,
        tags: [],
        title: ``,
        hasYesNoQuestion: false,
        imagebase64: ``,
        htmlContent: ``,
        surveyText: ``
    }
    return post;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        navigateTo: path => dispatch(push(path)),
        goBack: () => dispatch(goBack()),

        newPost: () => {
            return dispatch({
                type: KeysPost.NEWPOST,
            })
        },
        savePost: (post: post) => {
            const path = post._id ? '/api/Posts/' + post._id : '/api/Posts';
            return dispatch({
                type: KeysPost.ADDPOST,
                payload: invokeApi({
                    path: path,
                    method: 'POST',
                    body: post,
                    responseType: 'json'
                })
            })
        },
        loadDrafts: (title: string = '', description: string = '', yesNoQuestion: boolean = false) => {
            dispatch({
                type: KeysPost.LOADPOSTSUNDELIVERED,
                payload: invokeApi({
                    path: `/api/Posts/drafts?title=${title}&description=${description}&yesNoQuestion=${yesNoQuestion}`,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        loadDelivered: (title: string = '', description: string = '', yesNoQuestion: boolean = false) => {
            dispatch({
                type: KeysPost.LOADPOSTSDELIVERED,
                payload: invokeApi({
                    path: `/api/Posts/delivered?title=${title}&description=${description}&yesNoQuestion=${yesNoQuestion}`,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        getContent: (post: post) => {
            let path = '/api/Posts/' + post._id + '/content/resized'
            dispatch({
                type: KeysPost.GETCONTENT,
                payload: invokeApi({
                    path: path,
                    method: 'GET',
                    responseType: 'json'
                }),
                meta: post
            })
        },
        deliverPost: (post: post) => {
            dispatch({
                type: KeysPost.DELIVERYPOST,
                payload: invokeApi({
                    path: '/api/Posts/' + post._id + '/deliver',
                    method: 'POST',
                    body: post,
                    responseType: 'json'
                })
            })
        },
        getPost: (Id: string) => {
            dispatch({
                type: KeysPost.GETPOST,
                payload: invokeApi({
                    path: '/api/Posts/' + Id,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        deletePost: (Id: string) => new Promise((resolve, reject) => {
            dispatch({
                type: KeysPost.DELETEPOST,
                payload: invokeApi({
                    path: '/api/Posts/' + Id,
                    method: 'DELETE',
                    responseType: 'text'
                })
                    .then(res => {
                        resolve(res);
                        return res;
                    })
                    .catch(err => {
                        reject(err);
                        throw (err);
                    })
            })
        }),
        changeDescription: (post: post, newValue: string) => {
            dispatch({
                type: KeysPost.CHANGE_DESCRIPTION,
                payload: AlterDescription(post, newValue)
            })
        },
        changeSurveyText: (post: post, newValue: string) => {
            dispatch({
                type: KeysPost.CHANGE_SURVEYTEXT,
                payload: AlterSurveyText(post, newValue)
            })
        },
        changeTitle: (post: post, newValue: string) => {
            dispatch({
                type: KeysPost.CHANGE_TITLE,
                payload: AlterTitle(post, newValue)
            })
        },
        changeRTE: (post: post, newValue: string) => {
            dispatch({
                type: KeysPost.CHANGE_RTE,
                payload: AlterRTE(post, newValue)
            })
        },
        changeAssociatedTag: (post: post, tag: tag) => {
            dispatch({
                type: KeysPost.CHANGE_ASSOCIATEDTAG,
                payload: AlterAssociatedTag(post, tag)
            })
        },
        changeYesNoQuestion: (post: post, newValue: boolean) => {
            dispatch({
                type: KeysPost.CHANGE_YESNOQUESTION,
                payload: alterYESNO(post, newValue)
            })
        },
        clearFields: () => {
            dispatch({
                type: KeysPost.CLEAR_FIELDS,
                payload: clearFields()
            })
        },
        loadVotes: (idPost: string) => {
            return dispatch({
                type: KeysPost.LOADVOTES,
                payload: invokeApi({
                    path: '/api/Votes?IdPost=' + idPost,
                    method: 'GET',
                    responseType: 'json',
                }),
                meta: { _id: idPost }

            })
        },
        loadStatsVote: (idPost: string) => {
            return dispatch({
                type: KeysPost.LOADVOTESTATS,
                payload: invokeApi({
                    path: '/api/Votestats?IdPost=' + idPost,
                    method: 'GET',
                    responseType: 'json'
                }),
                meta: { _id: idPost }
            })
        },
        changeImageBase64: (post: post, newValue: string) => {
            dispatch({
                type: KeysPost.CHANGE_IMAGEBASE64,
                payload: alterImageBase64(post, newValue)
            })
        },
        print: (tagIds: string[]) => {
            dispatch({
                type: KeysPost.PRINT,
                payload: invokeApi({
                    path: '/api/Posts/print',
                    method: 'POST',
                    body: tagIds,
                    responseType: 'json'
                }),
            })
        },
        download: (tagIds: string[]) => {
            dispatch({
                type: KeysPost.DOWNLOAD,
                payload: invokeApi({
                    path: '/api/Posts/download',
                    method: 'POST',
                    body: tagIds,
                    responseType: 'json'
                }),
            })
        },
    }
}